class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.querySelector('cart-drawer');
    this.refreshRequestId = 0;
    // 弃用请求的方式 改用liquid 模版
    // new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    // 如果当前路径是'/cart'，则代表是主购物车页面，否则是侧边栏购物车
    const isMainCart = window.location.pathname === '/cart';

    // mount this to container
    const targetContainer = document.querySelector('div#' + this.dataset.targetContainerId);
    if (!isMainCart && targetContainer && targetContainer.parentNode) {
      // 将this插入到targetContainer的父节点中，放在targetContainer的位置
      this.style.display = 'block';
      targetContainer.parentNode.insertBefore(this, targetContainer);
      // 移除原来的targetContainer
      targetContainer.parentNode.removeChild(targetContainer);

      this.bindClickEventAndUpdateUnfitTips();
    }

    // 浏览器后退/前进从 bfcache 恢复时，页面 DOM 是离开时的快照，购物车会过期
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) this.refreshContents(false);
    });

    // 点击导航栏购物车图标打开侧边栏时，重新拉取最新购物车
    if (this.drawer) {
      const summaryElement = this.drawer.querySelector('summary');
      summaryElement?.addEventListener('click', () => {
        // 加购后 open() 会主动 click summary，此时内容已由 renderContents 更新，跳过重复请求
        if (this.skipNextOpenRefresh) {
          this.skipNextOpenRefresh = false;
          return;
        }
        const detailsElement = this.drawer.querySelector('details');
        if (detailsElement && !detailsElement.hasAttribute('open')) {
          this.refreshContents(false);
        }
      });
    }
  }

  updateUnfitTips() {
    if (!this.cartItemsElement) this.cartItemsElement = document.querySelector('cart-items');
    if (this.cartItemsElement) {
      this.cartItemsElement.updateUnfitTips();
    }
  }

  bindClickEventAndUpdateUnfitTips() {
    this.updateUnfitTips();

    const miniCartFormSubmitButton = document.querySelector('form#cart button.submit-button');
    if (miniCartFormSubmitButton) miniCartFormSubmitButton.addEventListener('click', (e) => this.cartItemsElement.handleCheckout(e));
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const miniCartElement = document.getElementById('mini-cart');
        miniCartElement.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
        this.bindClickEventAndUpdateUnfitTips();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  /**
   * 从 Section Rendering API 拉取最新 mini-cart / 角标，覆盖本地过期 DOM
   * @param {boolean} isOpenDrawer 拉取完成后是否打开侧边栏
   */
  refreshContents(isOpenDrawer = false) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const sectionIds = [...new Set(this.getSectionsToRender().map((section) => section.section))];
    const requestId = ++this.refreshRequestId;

    return fetch(`${root}?sections=${sectionIds.join(',')}`)
      .then((response) => response.json())
      .then((sections) => {
        if (requestId !== this.refreshRequestId) return;
        this.renderContents({ sections }, isOpenDrawer);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    const summaryElement = this.drawer.querySelector('summary');
    this.skipNextOpenRefresh = true;
    summaryElement.click();

    setTimeout(() => {
      setHeaderHeight();
    }, 250);
  }

  closeMenuDrawer() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      const summaryElement = this.drawer.querySelector('summary');
      this.skipNextOpenRefresh = true;
      summaryElement.click();

      setTimeout(() => {
        setHeaderHeight();
      }, 250);
    }
  }

  renderContents(parsedState, isOpenDrawer = true) {
    if (!parsedState || !parsedState.sections) return;

    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);

      if (element) {
        const elementToReplace = element.querySelector(section.selector) || element;
        const html = parsedState.sections[section.section]
          ? this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
          : null;
        if (elementToReplace && html != null) {
          elementToReplace.innerHTML = html;
        }
      }
    });

    this.syncEmptyState(parsedState);

    if (this.header) this.header.reveal();
    if (isOpenDrawer) this.open();
    setTimeout(() => {
      this.bindClickEventAndUpdateUnfitTips();
      // cart 列表 data-cart-sku 已更新，需同步 mini-cart__bundle-section 显隐
      this.updateBundleSectionVisibility();
      if (window.CartBundleDiscount && typeof window.CartBundleDiscount.refresh === 'function') {
        window.CartBundleDiscount.refresh().catch(() => {});
      }
    }, 250);
  }

  /**
   * CSS 异步加载或竞态替换后，强制校正空状态，避免「空购物车文案 + 商品列表」叠层。
   */
  syncEmptyState(parsedState) {
    const cartItemsRoot = document.getElementById('mini-cart-bundle-items');
    if (!cartItemsRoot) return;

    const emptyEl = cartItemsRoot.querySelector('.mini-cart__empty');
    const nav = cartItemsRoot.querySelector('.mini-cart__navigation');
    const itemCountFromDom = nav ? nav.querySelectorAll(':scope > li').length : 0;
    const itemCountFromState =
      parsedState && typeof parsedState.item_count === 'number' ? parsedState.item_count : null;
    const isEmpty = itemCountFromState != null ? itemCountFromState === 0 : itemCountFromDom === 0;

    if (emptyEl) {
      emptyEl.classList.toggle('is-empty', isEmpty);
      if (isEmpty) {
        emptyEl.style.removeProperty('display');
      } else {
        emptyEl.style.setProperty('display', 'none', 'important');
      }
    }

    cartItemsRoot.classList.toggle('is-empty', isEmpty);
  }

  /**
   * 根据当前购物车 SKU 刷新侧栏「经典套装」推荐区（加购/删除配件后需重算显隐）
   */
  updateBundleSectionVisibility() {
    document.querySelectorAll('mini-cart-bundle-item').forEach((item) => {
      if (typeof item.openDrawer === 'function') item.openDrawer();
    });
  }

  getSectionsToRender() {
    return [
      // 更新小购物车商品列表
      {
        id: 'mini-cart-bundle-items',
        section: 'mini-cart',
        selector: '#mini-cart-bundle-items',
      },
      // 更新小购物车 footer
      {
        id: 'mini-cart__footer_id',
        section: 'mini-cart',
        selector: '.mini-cart__footer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
